const installations = [
    {
        id: 0,
        name: 'Velammal Hospitals',
        city: 'Chennai',
        state: 'Tamil Nadu',
        lat: 13.0827,
        lng: 80.2707,
        location: 'Velammal Hospitals, Chennai, Tamil Nadu',
    },
    {
        id: 1,
        name: 'Accura Speciality Lab',
        city: 'Chennai',
        state: 'Tamil Nadu',
        lat: 13.0950,
        lng: 80.2820,
        location: 'Accura Speciality Lab, Chennai, Tamil Nadu',
    },
    {
        id: 2,
        name: 'Vanavil Scans',
        city: 'Chennai',
        state: 'Tamil Nadu',
        lat: 13.0670,
        lng: 80.2610,
        location: 'Vanavil Scans, Chennai, Tamil Nadu',
    },
    {
        id: 3,
        name: 'Apollo Hospitals',
        city: 'Chennai',
        state: 'Tamil Nadu',
        lat: 13.0730,
        lng: 80.2200,
        location: 'Apollo Hospitals, Chennai, Tamil Nadu',
    },
    {
        id: 4,
        name: 'ES Hospital',
        city: 'Villupuram',
        state: 'Tamil Nadu',
        lat: 11.9401,
        lng: 79.4861,
        location: 'ES hospital, Villupuram, Tamil Nadu',
    },
    {
        id: 5,
        name: 'Subha Anandham Hospital',
        city: 'Cuddalore',
        state: 'Tamil Nadu',
        lat: 11.7480,
        lng: 79.7714,
        location: 'Subha Anandham Hospital, Cuddalore, Tamil Nadu',
    },
    {
        id: 6,
        name: 'Mahatma Gandhi Medical College',
        city: 'Pondicherry',
        state: 'Tamil Nadu',
        lat: 11.9416,
        lng: 79.8083,
        location: 'Mahatma Gandhi Medical College, Pondicherry, Tamil Nadu',
    },
    {
        id: 7,
        name: 'G. Kuppuswamy Naidu Memorial Hospital',
        city: 'Coimbatore',
        state: 'Tamil Nadu',
        lat: 11.0050,
        lng: 76.9650,
        location: 'G. Kuppuswamy Naidu Memorial Hospital, Coimbatore, Tamil Nadu',
    },
    {
        id: 8,
        name: 'KG Hospital',
        city: 'Coimbatore',
        state: 'Tamil Nadu',
        lat: 11.0300,
        lng: 76.9700,
        location: 'KG Hospital Coimbatore, Tamil Nadu',
    },
    {
        id: 9,
        name: 'GKNM Hospital',
        city: 'Coimbatore',
        state: 'Tamil Nadu',
        lat: 11.0168,
        lng: 76.9558,
        location: 'GKNM Hospital, Coimbatore, Tamil Nadu',
    },
    {
        id: 10,
        name: 'PSG Hospital',
        city: 'Coimbatore',
        state: 'Tamil Nadu',
        lat: 11.0200,
        lng: 76.9400,
        location: 'PSG Hospital, Coimbatore, Tamil Nadu',
    },
    {
        id: 11,
        name: 'Erode Cancer Centre',
        city: 'Erode',
        state: 'Tamil Nadu',
        lat: 11.3410,
        lng: 77.7172,
        location: 'Erode Cancer Centre, Erode, Tamil Nadu',
    },
    {
        id: 12,
        name: 'Soorya Multispeciality Hospital',
        city: 'Thiruchengode',
        state: 'Tamil Nadu',
        lat: 11.4610,
        lng: 77.8964,
        location: 'Soorya Multispeciality Hospital, Thiruchengode, Tamil Nadu',
    },
    {
        id: 13,
        name: 'Meenakshi Mission Hospital and Research Centre',
        city: 'Madurai',
        state: 'Tamil Nadu',
        lat: 9.9252,
        lng: 78.1198,
        location: 'Meenakshi Mission Hospital and Research Centre, Madurai, Tamil Nadu',
    },
    {
        id: 14,
        name: 'KSDC Hospital',
        city: 'Tanjore',
        state: 'Tamil Nadu',
        lat: 10.7870,
        lng: 79.1378,
        location: 'KSDC Hospital, Tanjore, Tamil Nadu',
    },
    {
        id: 15,
        name: 'Jeeva Centenary Trust',
        city: 'Tanjore',
        state: 'Tamil Nadu',
        lat: 10.8000,
        lng: 79.1500,
        location: 'Jeeva Centenary Trust, Tanjore, Tamil Nadu',
    },
    {
        id: 16,
        name: 'Annal Gandhi Memorial Hospital',
        city: 'Trichy',
        state: 'Tamil Nadu',
        lat: 10.7905,
        lng: 78.7047,
        location: 'Annal Gandhi Memorial Hospital, Trichy, Tamil Nadu',
    },
];

export default installations;